<template>
    <el-container>
        <!-- 头部 -->
        <div class="banner" v-if="is_show&&adList.length>0">
            <el-carousel height="70px" arrow="hover" direction="vertical" indicator-position="none">
                <el-carousel-item v-for="item in adList" :key="item.adv_id" :style="{ backgroundColor: item.background }">
                    <el-image :src="$img(item.adv_image)" fit="cover" @click="$router.pushToTab(item.adv_url.url)" />
                </el-carousel-item>
            </el-carousel>
            <i class="el-icon-circle-close" @click="closeAd"></i>
        </div>
        <el-header ><ns-header :hasBg="hasBg" /></el-header>
        <el-main :style="returnIndexStyle">
            <transition name="slide"><router-view /></transition>

            <!-- 右侧栏 -->
            <ns-aside />
        </el-main>
        <!-- 底部 -->
        <el-footer><ns-footer /></el-footer>
        <div class="bg-img" v-if="hasBg">
            <el-image :src="$img(moreConfig.more_setting.pc_bg_img)" fit="cover" />
        </div>
    </el-container>
</template>
<script>
    import { floatLayer } from "@/api/pc"
import http from '@/utils/http'
import { adList } from "../api/website"
import NsAside from "./components/NsAside"
import NsFooter from "./components/NsFooter"
import NsHeader from "./components/NsHeader"
    export default {
        name: "Layout",
        components: {
            NsHeader,
            NsFooter,
            NsAside
        },
        created() {
            this.getAdList();
            // this.getFloatLayer();
        },
        data: () => {
            return {
                loadingAd: true,
                adList: [],
                is_show: true,
                indexTopAdNum: 0,
                moreConfig:{}
            }
        },
        mounted() {
            this.getMoreConfig();
        },
        computed: {
            returnIndexStyle(){
                if(this.moreConfig&&this.moreConfig.more_setting&&this.moreConfig.more_setting.pc_bg_img){
                    return{
                        borderTop:'none'
                    }
                }
                return{}
            },
            hasBg(){
                let path = this.$route.path;
                let hasBg = false;
                if(path!='/index'){
                    return hasBg;
                }
                if(this.moreConfig&&this.moreConfig.more_setting&&this.moreConfig.more_setting.pc_bg_img){
                    hasBg = true;
                }
                return hasBg;
            }
        },
        watch: {},
        methods: {
            getFloatLayer() {
                floatLayer().then(res => {
                    if (res.code == 0 && res.data) {
                        this.isShowFloatLayer(res.data)
                    }
                })
            },
            isShowFloatLayer(data){
                const currentTime = new Date().getTime();
                let startTime = new Date(data.startTime).getTime();
                let endTime = new Date(data.endTime).getTime();
                if(currentTime >= startTime && currentTime <= endTime){
                    let httpTime = localStorage.getItem('httpTime_top');
                    if(!httpTime){
                        localStorage.setItem('httpTime_top',JSON.stringify([startTime,endTime]));
                    }else{
                        let httpTimeList = JSON.parse(httpTime);
                        if(parseInt(httpTimeList[0]) != startTime || parseInt(httpTimeList[1]) != endTime){
                            localStorage.setItem('httpTime_top',JSON.stringify([startTime,endTime]));
                            localStorage.removeItem('isShowFloatLayer_top');
                            localStorage.removeItem('showTime_top');
                        }
                    }
                    let showType = localStorage.getItem('showType_top');
                    if(showType&&showType!=data.type){
                        localStorage.removeItem('isShowFloatLayer_top');
                        localStorage.removeItem('showTime_top');
                    }
                    let isShow = localStorage.getItem('isShowFloatLayer_top');
                    let showTime = localStorage.getItem('showTime_top');
                    if(data.type==='1'){
                        if(!isShow){
                            this.is_show = true;
                            localStorage.setItem('isShowFloatLayer_top',true);
                        }
                    }else if(data.type==='2'){
                        this.is_show = true;
                    }else if(data.type==='3'){
                        if(!isShow){
                            localStorage.setItem('isShowFloatLayer_top',true);
                            localStorage.setItem('showTime_top',JSON.stringify(currentTime));
                            this.is_show = true;
                        }else{
                            if(parseInt(currentTime) - parseInt(showTime) > 1000*60*60*24){
                                localStorage.setItem('isShowFloatLayer_top',true);
                                localStorage.setItem('showTime_top',JSON.stringify(currentTime));
                                this.is_show = true;
                            }
                        }
                    }
                    localStorage.setItem('showType_top',data.type);
                }
            },
            getAdList() {
                adList({ keyword: "NS_PC_INDEX_TOP" }).then(res => {
                    this.adList = res.data.adv_list
                    for (let i = 0; i < this.adList.length; i++) {
                        if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url)
                    }
                })
            },
            closeAd() {
                this.is_show = false;
            },
            async getMoreConfig() {
                let res = await http({ url: "/pc/api/pc/moreConfig" })
                const { code, data } = res
                if (code >= 0) {
                    this.moreConfig = data;
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    .banner {
        text-align: center;
        height: 70px;
        position: relative;
        i {
            font-size: 30px;
            position: absolute;
            z-index: 100;
            right: 115px;
            top: 10px;
            cursor: pointer;
            color: #d4d4d4;
        }
    }
    .el-header {
        padding: 0;
        height: 200px !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .el-main{
        min-height: calc(100vh - 680px);
    }
    .bg-img{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        .el-image{
            width: 100%;
            height: 100%;
        }
    }
</style>
